// store.js
import { configureStore } from "@reduxjs/toolkit";
import apiReducer from "./apiReducer";
import reducer from "./reducer";
import menuReducer from "./menuReducer";

// Create Redux store
const store = configureStore({
  reducer: {
    menu: menuReducer,
    api: apiReducer,  // Attach your API reducer'
    state: reducer, // Attach your main reducer
  },
});

export default store;
